import {
  GET_FEATURES_FLAGS,
  GET_FEATURES_FLAGS_SUCCESS,
  GET_FEATURES_FLAGS_ERROR,
  CREATE_FEATURES_FLAG,
  CREATE_FEATURES_FLAG_SUCCESS,
  CREATE_FEATURES_FLAG_ERROR,
  ENABLE_FEATURES_FLAG,
  ENABLE_FEATURES_FLAG_SUCCESS,
  ENABLE_FEATURES_FLAG_ERROR,
  DISABLE_FEATURES_FLAG,
  DISABLE_FEATURES_FLAG_SUCCESS,
  DISABLE_FEATURES_FLAG_ERROR,
  TOGGLE_FEATURES_FLAGS_ACCOUNTS_SUCCESS,
  TOGGLE_FEATURES_FLAGS_ACCOUNTS_ERROR,
  TOGGLE_FEATURES_FLAGS_ACCOUNTS,
  TOGGLE_FEATURES_FLAGS_ADMIN_USERS_ERROR,
  TOGGLE_FEATURES_FLAGS_ADMIN_USERS_SUCCESS,
  TOGGLE_FEATURES_FLAGS_ADMIN_USERS,
  GET_WHITELISTED_BRANDS_FEATURE_FLAGS,
  GET_WHITELISTED_BRANDS_FEATURE_FLAGS_SUCCESS,
  GET_WHITELISTED_BRANDS_FEATURE_FLAGS_ERROR,
  CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS,
  CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS_SUCCESS,
  CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS_ERROR,
  DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS,
  DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS_SUCCESS,
  DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS_ERROR
} from "./actionTypes"

export const getFeaturesFlags = () => {
  return {
    type: GET_FEATURES_FLAGS
  }
}

export const getFeaturesFlagsSuccess = featuresFlags => {
  return {
    type: GET_FEATURES_FLAGS_SUCCESS,
    payload: featuresFlags,
  }
}

export const getFeaturesFlagsError = error => {
  return {
    type: GET_FEATURES_FLAGS_ERROR,
    payload: error,
  }
}

export const createFeaturesFlag = (featuresFlags) => {
  return {
    type: CREATE_FEATURES_FLAG,
    payload: featuresFlags
  }
}

export const createFeaturesFlagSuccess = featuresFlags => {
  return {
    type: CREATE_FEATURES_FLAG_SUCCESS,
    payload: featuresFlags,
  }
}

export const createFeaturesFlagError = error => {
  return {
    type: CREATE_FEATURES_FLAG_ERROR,
    payload: error,
  }
}


export const enableFeaturesFlag = (featuresFlags) => {
  return {
    type: ENABLE_FEATURES_FLAG,
    payload: featuresFlags
  }
}

export const enableFeaturesFlagSuccess = featuresFlags => {
  return {
    type: ENABLE_FEATURES_FLAG_SUCCESS,
    payload: featuresFlags,
  }
}

export const enableFeaturesFlagError = error => {
  return {
    type: ENABLE_FEATURES_FLAG_ERROR,
    payload: error,
  }
}

export const disableFeaturesFlag = (featuresFlags) => {
  return {
    type: DISABLE_FEATURES_FLAG,
    payload: featuresFlags
  }
}

export const disableFeaturesFlagSuccess = featuresFlags => {
  return {
    type: DISABLE_FEATURES_FLAG_SUCCESS,
    payload: featuresFlags,
  }
}

export const disableFeaturesFlagError = error => {
  return {
    type: DISABLE_FEATURES_FLAG_ERROR,
    payload: error,
  }
}

export const toggleFeaturesFLagsAdminUsers = (featuresFlags) => {
  return {
    type: TOGGLE_FEATURES_FLAGS_ADMIN_USERS,
    payload: featuresFlags
  }
}

export const toggleFeaturesFLagsAdminUsersSuccess = featuresFlags => {
  return {
    type: TOGGLE_FEATURES_FLAGS_ADMIN_USERS_SUCCESS,
    payload: featuresFlags,
  }
}

export const toggleFeaturesFLagsAdminUsersError = error => {
  return {
    type: TOGGLE_FEATURES_FLAGS_ADMIN_USERS_ERROR,
    payload: error,
  }
}

export const toggleFeaturesFLagsAccounts = (featuresFlags) => {
  return {
    type: TOGGLE_FEATURES_FLAGS_ACCOUNTS,
    payload: featuresFlags
  }
}

export const toggleFeaturesFLagsAccountsSuccess = featuresFlags => {
  return {
    type: TOGGLE_FEATURES_FLAGS_ACCOUNTS_SUCCESS,
    payload: featuresFlags,
  }
}

export const toggleFeaturesFLagsAccountsError = error => {
  return {
    type: TOGGLE_FEATURES_FLAGS_ACCOUNTS_ERROR,
    payload: error,
  }
}

export const getWhitelistedBrandsFeatureFlags = (data) => {
  return {
    type: GET_WHITELISTED_BRANDS_FEATURE_FLAGS,
    payload: data
  }
}

export const getWhitelistedBrandsFeatureFlagsSuccess = (brand_feature_flag) => {
  return {
    type: GET_WHITELISTED_BRANDS_FEATURE_FLAGS_SUCCESS,
    payload: brand_feature_flag,
  }
}

export const getWhitelistedBrandsFeatureFlagsError = error => {
  return {
    type: GET_WHITELISTED_BRANDS_FEATURE_FLAGS_ERROR,
    payload: error,
  }
}

export const createWhitelistedBrandsFeatureFlags = (data) => {
  return {
    type: CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS,
    payload: data
  }
}

export const createWhitelistedBrandsFeatureFlagsSuccess = (brand_feature_flag) => {
  return {
    type: CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS_SUCCESS,
    payload: brand_feature_flag,
  }
}

export const createWhitelistedBrandsFeatureFlagsError = error => {
  return {
    type: CREATE_WHITELISTED_BRANDS_FEATURE_FLAGS_ERROR,
    payload: error,
  }
}

export const deleteWhitelistedBrandsFeatureFlags = (data) => {
  return {
    type: DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS,
    payload: data
  }
}

export const deleteWhitelistedBrandsFeatureFlagsSuccess = (brand_feature_flag) => {
  return {
    type: DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS_SUCCESS,
    payload: brand_feature_flag,
  }
}

export const deleteWhitelistedBrandsFeatureFlagsError = error => {
  return {
    type: DELETE_WHITELISTED_BRANDS_FEATURE_FLAGS_ERROR,
    payload: error,
  }
}